import axios from "axios";
import { tmsApi } from "../api";

export const getCarList = (obj) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .post(tmsApi + `v1/entities/car/list?page=${obj.page}&size=${obj.size}`, {
                serviceCityId: obj.serviceCityId
            }, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const getCarListBySearch = (obj) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .post(tmsApi + `v1/entities/car/search/bycarno?page=${obj.page}&size=${obj.size}`, {
                serviceCityId: obj.serviceCityId,
                carNo: obj.carNo
            }, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const getCarListByFilter = (obj) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .post(tmsApi + `v1/entities/car/filter?page=${obj.page}&size=${obj.size}`, obj, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const getTripsByCarId = (obj) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .post(tmsApi + `v1/services/car/trips?page=${obj.page}&size=${obj.size}`, {
                id: obj.carId,
                serviceCityId: obj.serviceCityId,
            }, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const getBatteryTransactionsByCarId = (obj) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .post(tmsApi + `v1/entities/evcar/battery/percentages?page=${obj.page}&size=${obj.size}`, {
                id: obj.carId,
            }, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const getUnavailableCarsList = (obj) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .get(tmsApi + `v1/entities/carunavailableByServiceCityId/${obj.serviceCityId}?page=${obj.page}&size=${obj.size}`, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const getUnavailableCarsListBySearch = (obj) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .get(tmsApi + `v1/entities/carunavailableByServiceCityId/search/${obj.serviceCityId}/${obj.carNo}?page=${obj.page}&size=${obj.size}`, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const getFuelTypes = () => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .get(tmsApi + `v1/entities/fueltype`, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const getCarDetail = (carId) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .get(tmsApi + `v1/entities/car/${carId}`, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const createCar = (body) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .post(tmsApi + `v1/entities/car`, body, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const updateCar = (body) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .put(tmsApi + `v1/entities/car`, body, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const uploadCarDocuments = (body) => {
    const config = {
        headers: {
            token: `${localStorage.getItem('token')}`,
            "Access-Control-Allow-Origin": "*",
            'Content-Type': 'multipart/form-data'
        },
    };
    try {
        return axios.post(tmsApi + "v1/entities/car/documents/upload", body, config).then((resp) => {
            console.log(resp, "response");
            return resp;
        });
    } catch (error) {
        console.log("error", error);
        return error
    }
};

export const getCarDocuments = (carNo) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .get(tmsApi + `v1/entities/car/documents/listing?carNo=${carNo}`, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const CarDocumentDownload = (obj) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .get(tmsApi + `v1/entities/car/documents/download?key=${obj.key}&fileName=${obj.fileName}&carNo=${obj.carNo}&isEverything=false`, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const blockCar = (body) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .post(tmsApi + `v1/services/unavailablecar`, body, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const unblockCar = (body) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .put(tmsApi + `v1/services/unavailablecar`, body, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const getblockCarDetails = (carNo) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .post(tmsApi + `v1/entities/carunavailable/carno`, {
                carNo: carNo
            }, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const deleteCar = (id,isDeleted) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .delete(tmsApi + `v1/entities/car/${id}?isDeleted=${isDeleted}`, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const getAllCarType = (obj)=>{
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    }
    try{
        // https://dev.megacabs.com/tms/api/v1/entities/cartype/all
        return axios.get(tmsApi + `v1/entities/cartype/all`,config).then((resp)=>{
        // return axios.get(tmsApi + `v1/entities/cartype?page=${obj.page}&size=${obj.size}`,config).then((resp)=>{
            return resp;
        })
    }catch(err){
        console.log("error",err)
    }
}

export const createCarType =(obj)=>{

    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    }
    try{
        return axios.post(tmsApi + "v1/entities/cartype/create",obj,config).then((resp)=>{
            return resp;
        })
    }catch(error){
        console.log("error", error);
    }

}

export const updateCarType=(obj)=>{
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    }
    try{
        return axios.put(tmsApi + "v1/entities/cartype/update",obj,config).then((resp)=>{
            return resp;
        })
    }catch(error){
        console.log("error", error);
    }
}

export const deleteCarType=(obj)=>{
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    }
    try{
        return axios.put(tmsApi + `v1/entities/cartype/${obj.id}`,config).then((resp)=>{
            return resp;
        })
    }catch(error){
        console.log("error", error);
    }
}

export const getCarTypeByCity=(cityId)=>{
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    }
    try{
        return axios.get(tmsApi + `v1/entities/cartype/list/${cityId}`,config).then((resp)=>{
            return resp;
        })
    }catch(error){
        console.log("error", error);
    }
}

export const searchCarType=(obj)=>{
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    }
    try{
        return axios.get(tmsApi + `v1/entities/cartype/find`,obj,config).then((resp)=>{
            return resp;
        })
    }catch(error){
        console.log("error", error);
    }
}


export const deleteRecoverCarType=(obj)=>{
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    }
    try{
        return axios.delete(tmsApi + `v1/entities/cartype/${obj.id}?isDeleted=${obj.IsDeleted}`,config).then((resp)=>{
            return resp;
        })
    }catch(error){
        console.log("error", error);
    }
}